export const IndicatorType = {
  RSI: 'RSI',
  MA: 'MA',
  VWAP: 'VWAP',
  MACD: 'MACD',
  ORDER_BLOCKS: 'ORDER_BLOCKS',
  ZIG_ZAG: 'ZIG_ZAG',
  MASTER_PATTERN: 'MASTER_PATTERN',
  MARKET_STRUCTURE: 'MARKET_STRUCTURE',
  LIQUIDATION: 'LIQUIDATION'
} as const;

export const SignalType = {
  RSI: 'RSI',
  // RSI_AVERAGE_UP: 'RSI_AVERAGE_UP',
  // RSI_AVERAGE_DOWN: 'RSI_AVERAGE_DOWN',
  // HIGHER_CLOSE: 'HIGHER_CLOSE',
  // LOWER_CLOSE: 'LOWER_CLOSE',
  // MACD_BULLISH_CROSS: 'MACD_BULLISH_CROSS',
  // MACD_BEARISH_CROSS: 'MACD_BEARISH_CROSS',
  MA: 'MA',
  // MA_UP: 'MA_UP',
  // MA_DOWN: 'MA_DOWN',
  // SUPPLY_ZONE_FLIP: 'SUPPLY_ZONE_FLIP',
  // DEMAND_ZONE_FLIP: 'DEMAND_ZONE_FLIP',
  // SUPPLY_ZONE_CREATED: 'SUPPLY_ZONE_CREATED',
  // DEMAND_ZONE_CREATED: 'DEMAND_ZONE_CREATED',
  // SUPPLY_ZONE_RETEST: 'SUPPLY_ZONE_RETEST',
  // DEMAND_ZONE_RETEST: 'DEMAND_ZONE_RETEST',
  // SUPPLY_ZONE_BREAK: 'SUPPLY_ZONE_BREAK',
  // DEMAND_ZONE_BREAK: 'DEMAND_ZONE_BREAK',
  // TOUCHED_SUPPLY_ZONE: 'TOUCHED_SUPPLY_ZONE',
  // TOUCHED_DEMAND_ZONE: 'TOUCHED_DEMAND_ZONE',
  VALUE: 'VALUE',
  LIQUIDATION: 'LIQUIDATION'
} as const;

export const RelativePosition = {
  ABOVE: 'ABOVE',
  BELOW: 'BELOW'
} as const;

export const RsiMode = {
  AVERAGE_RELATIVE: 'AVERAGE_RELATIVE',
  LEVEL: 'LEVEL'
} as const;

export const MaRelativeMode = {
  TREND: 'TREND',
  PRICE_RELATIVE: 'PRICE_RELATIVE',
  PRICE_DEVIATION: 'PRICE_DEVIATION',
  SLOPE: 'SLOPE',
  REVERSAL: 'REVERSAL',
  MA_TO_MA: 'MA_TO_MA'
} as const;

export const MaTrendDirection = {
  UP: 'UP',
  DOWN: 'DOWN'
} as const;

export const MaSlopeNormalization = {
  PCT: 'PCT',
  ATR: 'ATR'
} as const;

export const ValueMode = {
  RELATIVE: 'RELATIVE',
  REACTION: 'REACTION'
} as const;

export const ValueReactionEvent = {
  RETEST: 'RETEST',
  BREAK: 'BREAK'
} as const;

export const ValueReactionDirection = {
  BULLISH: 'BULLISH',
  BEARISH: 'BEARISH'
} as const;

export const ValueReactionScope = {
  LATEST: 'LATEST',
  HISTORICAL: 'HISTORICAL'
} as const;

export const LiquidationSignalMode = {
  BULLISH: 'BULLISH',
  BEARISH: 'BEARISH'
} as const;

export const LiquidationIndicatorMode = {
  SWEEP: 'SWEEP',
  LIQUIDATION: 'LIQUIDATION'
} as const;

export const MaType = {
  SMA: 'SMA',
  EMA: 'EMA',
  WMA: 'WMA'
} as const;

export const VwapMode = {
  SESSION: 'SESSION',
  ANCHORED: 'ANCHORED',
  ROLLING: 'ROLLING',
  CUMULATIVE: 'CUMULATIVE'
} as const;

export const VwapSessionReset = {
  FOREX_NY_17: 'FOREX_NY_17',
  UTC_DAY: 'UTC_DAY',
  CUSTOM: 'CUSTOM'
} as const;

export const VwapAnchorType = {
  TIMESTAMP: 'TIMESTAMP',
  WEEK_OPEN: 'WEEK_OPEN',
  MONTH_OPEN: 'MONTH_OPEN'
} as const;

export const TradingMode = {
  LIVE: 'LIVE',
  BACKTESTING: 'BACKTESTING'
} as const;

export const ExchangeId = {
  BINANCE: 'BINANCE',
  COINBASE: 'COINBASE',
  KRAKEN: 'KRAKEN',
  BYBIT: 'BYBIT'
} as const;

export type IndicatorType = keyof typeof IndicatorType;
export type MaType = keyof typeof MaType;
export type VwapMode = keyof typeof VwapMode;
export type VwapSessionReset = keyof typeof VwapSessionReset;
export type VwapAnchorType = keyof typeof VwapAnchorType;
export type SignalType = keyof typeof SignalType;
export type TradingMode = keyof typeof TradingMode;
export type ExchangeId = keyof typeof ExchangeId;
export type RelativePosition = keyof typeof RelativePosition;
export type RsiMode = keyof typeof RsiMode;
export type MaRelativeMode = keyof typeof MaRelativeMode;
export type MaTrendDirection = keyof typeof MaTrendDirection;
export type MaSlopeNormalization = keyof typeof MaSlopeNormalization;
export type ValueMode = keyof typeof ValueMode;
export type ValueReactionEvent = keyof typeof ValueReactionEvent;
export type ValueReactionDirection = keyof typeof ValueReactionDirection;
export type ValueReactionScope = keyof typeof ValueReactionScope;
export type LiquidationSignalMode = keyof typeof LiquidationSignalMode;
export type LiquidationIndicatorMode = keyof typeof LiquidationIndicatorMode;
